/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const SEND_FACEBOOK_DM_DISPLAY_TYPE = 'Send Facebook DM'
const SEND_FACEBOOK_DM_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'

const isFacebookDmFormAction = R.propEq('type', SEND_FACEBOOK_DM_DISPLAY_TYPE)

const DM_COMPONENT_FIELDS = {
  STANDARD: {
    dmText: 'fbDmText',
    dmImageUrl: 'fbDmImageUrl',
    dmTemplateTitle: 'fbTemplateTitle',
    dmTemplateActionUrl: 'fbTemplateActionUrl'
  },
  FALLBACK: {
    dmText: 'fbDmFallbackText',
    dmImageUrl: 'fbDmFallbackImageUrl',
    dmTemplateTitle: 'fbTemplateFallbackTitle',
    dmTemplateActionUrl: 'fbTemplateFallbackActionUrl'
  },
  DEPLETED: {
    dmText: 'fbDmDepletedText',
    dmImageUrl: 'fbDmDepletedImageUrl',
    dmTemplateTitle: 'fbTemplateDepletedTitle',
    dmTemplateActionUrl: 'fbTemplateDepletedActionUrl'
  }
}
const isPlainTextResponse = dmType => action => {
  const { dmImageUrl } = DM_COMPONENT_FIELDS[dmType]
  return R.pipe(R.prop(dmImageUrl), R.either(R.isNil, R.isEmpty))(action)
}

const constructTemplateBackupMessage = dmType => action => {
  const {
    dmText,
    dmImageUrl,
    dmTemplateTitle,
    dmTemplateActionUrl
  } = DM_COMPONENT_FIELDS[dmType]
  return R.applySpec({
    attachment: {
      type: R.always('template'),
      payload: {
        elements: [
          {
            title: R.prop(dmTemplateTitle),
            subtitle: R.prop(dmText),
            image_url: R.prop(dmImageUrl),
            default_action: {
              url: R.prop(dmTemplateActionUrl),
              type: R.always('web_url'),
              webview_height_ratio: R.always('tall')
            }
          }
        ],
        template_type: R.always('generic')
      }
    }
  })(action)
}

const constructPlainTextResponse = R.applySpec({
  type: R.always(SEND_FACEBOOK_DM_WIDGET_TYPE),
  message: {
    message: {
      text: R.prop('fbDmText')
    },
    fallbackMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('FALLBACK')
        ),
        R.applySpec({ text: R.prop('fbDmFallbackText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('FALLBACK'))
        ),
        constructTemplateBackupMessage('FALLBACK')
      ]
    ]),
    depletedMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('DEPLETED')
        ),
        R.applySpec({ text: R.prop('fbDmDepletedText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('DEPLETED'))
        ),
        constructTemplateBackupMessage('DEPLETED')
      ]
    ]),
    recipient: {
      id: R.always('${senderId}')
    },
    messaging_type: R.always('RESPONSE')
  }
})

const constructImageTemplateResponse = R.applySpec({
  type: R.always(SEND_FACEBOOK_DM_WIDGET_TYPE),
  message: {
    message: {
      attachment: {
        type: R.always('template'),
        payload: {
          elements: [
            {
              title: R.prop('fbTemplateTitle'),
              subtitle: R.prop('fbDmText'),
              image_url: R.prop('fbDmImageUrl'),
              default_action: {
                url: R.prop('fbTemplateActionUrl'),
                type: R.always('web_url'),
                webview_height_ratio: R.always('tall')
              }
            }
          ],
          template_type: R.always('generic')
        }
      }
    },
    fallbackMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('FALLBACK')
        ),
        R.applySpec({ text: R.prop('fbDmFallbackText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('FALLBACK'))
        ),
        constructTemplateBackupMessage('FALLBACK')
      ]
    ]),
    depletedMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('DEPLETED')
        ),
        R.applySpec({ text: R.prop('fbDmDepletedText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('DEPLETED'))
        ),
        constructTemplateBackupMessage('DEPLETED')
      ]
    ]),
    recipient: {
      id: R.always('${senderId}')
    }
  }
})

const constructGenericTemplateAction = R.cond([
  [isPlainTextResponse('STANDARD'), constructPlainTextResponse],
  [R.T, constructImageTemplateResponse]
])

const constructCustomTemplateAction = R.applySpec({
  type: R.always(SEND_FACEBOOK_DM_WIDGET_TYPE),
  isCustomTemplate: R.always(true),
  message: R.pipe(
    R.prop('customDmTemplate'),
    JSON.parse,
    R.merge({ recipient: { id: '${senderId}' } })
  )
})

const convertFacebookDmFormActionToWidgetAction = R.cond([
  [R.propEq('action', 'TEMPLATE_GENERIC'), constructGenericTemplateAction],
  [R.propEq('action', 'TEMPLATE_CUSTOM'), constructCustomTemplateAction]
])

export { isFacebookDmFormAction, convertFacebookDmFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-dm.js